import { Button, Divider, Stack, Text } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import React from "react";
import Timeline from "../Timeline/index.js";
import FlightsContentSkeleton from "./components/FlightsContentSkeleton.js";
import { CloseIcon } from "@bookingcom/bui-assets-react/streamline";
import Frame from "../Frame/index.js";
import { ShareFlight } from "../ShareFlight/index.js";
import styles from "./FlightDetailsInner.module.css";
import { useSelector } from "react-redux";
import { useTrackVICheckedBaggage } from "../../../utils/experiments/funnel/flights_funnel_web_vi_checked_baggage.js";
import { DSATraceabilityModal } from "./components/DSATraceability/index.js";
import FlightDetailsInfoMobile from "./components/FlightDetailsInfo/FlightDetailsInfo.mobile.js";
import { WishlistWidgetWrapper } from "../WishlistWidgetWrapper/index.js";
import { SurveyTrackerLoader } from "../../remote/SurveyTrackerFlightsUniversal.js";
import { getFlightError } from "../../../store/flightDetails/selectors.js";
import { useFlightDetailsInnerMobileController } from "./useFlightDetailsInner.mobile.controller.js";
import { useFlightDetailsInnerEffectsMobile } from "./useFlightDetailsInnerEffects.mobile.js";
import { FlightDetailsFooterMobile } from "./components/FlightDetailsFooter/FlightDetailsFooter.mobile.js";
import FlightDetailsErrorMobile from "./components/FlightDetailsError.mobile.js";
import { FlightDetailsCampaignBadgeSection } from "./components/FlightDetailsCampaignBadgeSection.js";
const FLIGHT_DETAILS_STICKY_FOOTER_SPACER_ID = "flight-details-sticky-footer-spacer";
const FlightDetailsInner = ({ flight, flightToken, fetchStatus, onClose, onErrorClose, hideFooter, closeAriaLabel, hasPrefetchedBrandedFareOffers, alternativeFaresFlow }) => {
    const i18n = useI18n();
    const flightDetailsError = useSelector(getFlightError);
    const { isError, trackV2, modalTitle, closeBtnRef, onFlightSelect, campaignBadges, shouldShowWishlistWidget } = useFlightDetailsInnerMobileController({
        flight,
        flightToken,
        alternativeFaresFlow,
        hasPrefetchedBrandedFareOffers
    });
    useFlightDetailsInnerEffectsMobile({ flightToken, flight, isError, trackV2 });
    useTrackVICheckedBaggage();
    if (isError) {
        return (React.createElement(FlightDetailsErrorMobile, { onErrorClose: onErrorClose, onClose: onClose, flightDetailsError: flightDetailsError }));
    }
    return (React.createElement(Frame, { pt: 2, pb: 4, pl: 4, pr: 4 },
        React.createElement("div", { className: styles.header },
            React.createElement(Stack, { gap: 0, direction: "row" },
                React.createElement(Text, { variant: "headline_2", tagName: "h1", className: styles.headerCrossText }, modalTitle),
                React.createElement(Button, { size: "large", variant: "tertiary-neutral", ref: closeBtnRef, attributes: {
                        "aria-label": closeAriaLabel || i18n.trans(t("flights_action_close"))
                    }, icon: React.createElement(CloseIcon, null), onClick: () => {
                        trackV2("click_back_button");
                        onClose();
                    } }))),
        flight ? (React.createElement("div", null,
            React.createElement(Stack, { direction: "row", alignItems: "center", mixin: { paddingBlockEnd: 4 } },
                campaignBadges.length > 0 && React.createElement(FlightDetailsCampaignBadgeSection, { campaignBadges: campaignBadges }),
                shouldShowWishlistWidget && flight.offerKeyToHighlight && (React.createElement("div", { className: campaignBadges.length === 0 ? styles.withMargin : undefined },
                    React.createElement(WishlistWidgetWrapper, { flight: flight }))),
                React.createElement(Frame, null,
                    React.createElement(ShareFlight, { flight: flight }))),
            React.createElement(Timeline, { segments: flight.segments }),
            React.createElement(Stack, { gap: 4, mixin: { paddingBlockEnd: 4 } },
                React.createElement(Divider, null),
                React.createElement(FlightDetailsInfoMobile, { flight: flight, fetchStatus: fetchStatus })),
            fetchStatus === "success" && React.createElement(SurveyTrackerLoader, null),
            React.createElement(DSATraceabilityModal, { flight: flight }))) : (React.createElement(FlightsContentSkeleton, null)),
        !hideFooter && (React.createElement(React.Fragment, null,
            React.createElement("div", { id: FLIGHT_DETAILS_STICKY_FOOTER_SPACER_ID }),
            React.createElement(FlightDetailsFooterMobile, { flight: flight, onButtonClick: onFlightSelect })))));
};
export default FlightDetailsInner;
